import { render, staticRenderFns } from "./EmailThreadViewer.vue?vue&type=template&id=8cd44722&scoped=true"
import script from "./EmailThreadViewer.vue?vue&type=script&lang=js"
export * from "./EmailThreadViewer.vue?vue&type=script&lang=js"
import style0 from "./EmailThreadViewer.vue?vue&type=style&index=0&id=8cd44722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd44722",
  null
  
)

export default component.exports